import EditChildExtraBedPolicy from './EditChildExtraBedPolicy.container';

export default EditChildExtraBedPolicy;
